export default __webpack_public_path__ + "static/spot-illo-morph-dark-b7f9b762f6d851b4e7e012fadcf3e33d.mp4";